import HTTPClient from './http-client';

const END_POINT = '/infodata/city?uf=PR';
const loadCities = async () => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}`,
  );
}

export {
  loadCities
}
